'use client';

import { createWorkerQueryClient } from '@app-worker/query/createWorkerQueryClient/createWorkerQueryClient';
import { LanguageProvider } from '@app-worker/translation/LanguageProvider/LanguageProvider';
import { recordAutoRefresh } from '@app-worker/uiEvent/recordAutoRefresh/recordAutoRefresh';
import { AppLanguageCode } from '@repo/entities/AppLanguage';
import { AutoRefreshOnNewVersion } from '@repo/features/AutoRefreshOnNewVersion';
import { GlobalMutatingBackdrop } from '@repo/features/GlobalMutatingBackdrop';
import { AppProvider } from '@repo/features/AppProvider';
import { useRegisterServiceWorker } from '@repo/features/useRegisterServiceWorker';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';

const queryClient = createWorkerQueryClient();

/**
 * The theme and refresh callback carry functions, which a server component
 * cannot pass, so they are built here. The layout passes the language as a
 * string read from the cookie. It is also the client root, so it installs the
 * service worker (see `public/sw.js`).
 */
export const AppProviders = ({
  languageCode,
  children,
}: {
  languageCode: AppLanguageCode;
  children: ReactNode;
}) => {
  useRegisterServiceWorker();

  return (
    <>
      <AutoRefreshOnNewVersion recordReload={recordAutoRefresh} />
      <QueryClientProvider client={queryClient}>
        <AppProvider
          // `info` is the office's chat reply; as long as success because a
          // man shoveling won't look at his phone within three seconds.
          toastDurations={{
            success: 20000,
            error: 10000,
            warning: 10000,
            info: 20000,
          }}
        >
          <GlobalMutatingBackdrop />
          <LanguageProvider languageCode={languageCode}>
            {children}
          </LanguageProvider>
        </AppProvider>
      </QueryClientProvider>
    </>
  );
};
